import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'balancas'
const endpointLeitura = 'leitura'

async function getBalancas() {
    try {
        var data = await ServiceBase.getByParams(endpoint);
        return data;
    } catch (e) {
        throw e;
    }
}

async function getLeitura() {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${endpointLeitura}`);
        return data;
    } catch (e) {
        throw e;
    }
}

export const BalancaService = {
    getBalancas,
    getLeitura
}